import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { TOPIC_ORDER, TOPICS } from "../../../topics";
import { Wordmark } from "../../wordmark";
import avatar from "../../../../static/logo.png";

const SECONDARY_LINKS = [
  { label: "Projects", href: "/projects" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

const NAV_LINK =
  "flex-shrink-0 transition-colors duration-maker ease-maker hover:text-spark";

const TopicLinks: FunctionComponent = () => (
  <>
    {TOPIC_ORDER.map((key) => (
      <Link
        key={key}
        to={TOPICS[key].href}
        className={`${NAV_LINK} ${TOPICS[key].textClass}`}
      >
        {TOPICS[key].shortName}
      </Link>
    ))}
  </>
);

const SecondaryLinks: FunctionComponent<{ count: number }> = ({ count }) => (
  <>
    {SECONDARY_LINKS.slice(0, count).map(({ label, href }) => (
      <Link key={href} to={href} className={`${NAV_LINK} text-muted`}>
        {label}
      </Link>
    ))}
  </>
);

/** Home page header: topic nav row above the full-size wordmark. */
export const Masthead: FunctionComponent = () => (
  <header>
    <nav className="scrollbar-none flex justify-between gap-6 overflow-x-auto whitespace-nowrap px-gutter-sm pt-5 font-display text-ui font-semibold md:px-gutter">
      <div className="flex gap-6">
        <TopicLinks />
      </div>
      <div className="flex gap-6">
        <SecondaryLinks count={3} />
      </div>
    </nav>
    <div className="flex items-end justify-between gap-4 border-b-4 border-ink px-gutter-sm pb-5 pt-2 md:px-gutter">
      <Wordmark size="masthead" />
      <div className="flex items-center gap-3.5 pb-2.5">
        <p className="hidden text-right font-body text-xl italic leading-[1.3] md:block">
          A maker&rsquo;s notebook
          <br />
          by Nahuel Taibo
        </p>
        <img
          src={avatar}
          alt="Nahuel Taibo"
          className="h-10 w-10 rounded-full object-cover md:h-16 md:w-16"
        />
      </div>
    </div>
  </header>
);

/** Every other page: 40px wordmark with the nav beside it (below it under 1024px). */
export const CompactHeader: FunctionComponent = () => (
  <header className="flex flex-col gap-3 border-b-4 border-ink px-gutter-sm py-5 lg:flex-row lg:items-center lg:justify-between md:px-gutter">
    <Wordmark size="compact" />
    <nav className="scrollbar-none flex gap-6 overflow-x-auto whitespace-nowrap font-display text-ui font-semibold">
      <TopicLinks />
      <span className="text-line" aria-hidden="true">
        |
      </span>
      <SecondaryLinks count={2} />
    </nav>
  </header>
);
